import { useStore } from '@nanostores/react'
import { Dialog, VisuallyHidden } from 'radix-ui'
import { $isLoadingOverlayOpen } from '~/store/loading-overlay'

export function LoadingOverlay() {
  const isOpen = useStore($isLoadingOverlayOpen)

  return (
    <Dialog.Root open={isOpen} modal={false}>
      <Dialog.Portal>
        <Dialog.Content
          onInteractOutside={(e) => e.preventDefault()}
          onEscapeKeyDown={(e) => e.preventDefault()}
          className="fixed inset-0 z-[60] grid place-items-center bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
        >
          <VisuallyHidden.Root>
            <Dialog.Title>{'Loading'}</Dialog.Title>
          </VisuallyHidden.Root>
          <VisuallyHidden.Root>
            <Dialog.Description>{'Loading'}</Dialog.Description>
          </VisuallyHidden.Root>

          <svg
            className="size-9 animate-spin text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
